<template>
<div>
    <header>
        <div class="inr">
            <span class="prev">
                <a @click="$router.go(-1)">
                    <img src="@/assets/image/icon-prev.png" alt="뒤로가기">
                </a>
            </span>
            <h1>문의 내역</h1>
            <span class="edit">
                <router-link to="/inquiry/register">
                    새 문의작성
                </router-link>
            </span>
        </div>
    </header>
    <Footer />
    <main id="sub" class="notice">
        <div class="inr" v-if="inquiryList.length > 0">
            <div class="accordian-content-wrap">
                <div class="accordian faq">
                    <div class="accordian-item" v-for="(inquiry, idx) in inquiryList" :key="idx">
                        <div class="accordian-item-header after-arrow">
                            <h4>
                                <span class="inquiry-status" :class="inquiry.answer ? 'complete' : 'not-complete'">{{inquiry.answer ? "답변 완료" : "답변 대기"}}</span>
                                {{inquiry.title}}
                            </h4>
                        </div>
                        <div class="accordian-item-body">
                            <div class="accordian-item-content">
                                <span class="font-bold">문의 내용 ({{inquiry.created}})</span> : {{inquiry.content}}
                                <ul class="file-lists" v-if="inquiry.attachments.length > 0">
                                    <li class="file-list" v-for="(item, idx) in inquiry.attachments" :key="idx" style="padding:0;">
                                        <span class="file-title">
                                            <!-- <a :href="item.image_url" download>{{item.image_name}}</a> -->
                                            <a :href="item.image_url" data-toggle="lightbox">{{item.image_name}}</a>
                                        </span>
                                    </li>
                                </ul>
                            </div>
                            <div class="accordian-item-content" v-if="inquiry.answer">
                                <span class="font-bold">답변 내용 ({{inquiry.answer.created}})</span> : {{inquiry.answer.title}}<br>{{inquiry.answer.content}}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="no-result" v-else>
            <div class="no-result-txt" v-html="blankMsg">
            </div>
        </div>
    </main>
</div>
</template>

<script>
import Footer from "@/components/common/Footer";

export default {
    components: {
        Footer
    },
    data() {
        return {
            blankMsg: "",
            user_pk: this.$store.state.userInfo.pk,
            inquiryList: [],

            InquiryItemHeaders: null
        };
    },
    mounted() {
        this.axios.get(`/inquiry?user_pk=${this.user_pk}`).then(res => {
            res.data.result.forEach(item => {
                item.created = moment(item.created).format("YYYY-MM-DD");
                item.attachments = JSON.parse(item.attachments);
                if (item.answer) {
                    item.answer.created = moment(item.answer.created).format("YYYY-MM-DD");
                }
            });

            this.inquiryList = res.data.result;

            if (this.inquiryList.length > 0) {
                this.$nextTick(() => {
                    this.InquiryItemHeaders = document.querySelectorAll(
                        ".accordian-item-header"
                    );
                    this.InquiryItemHeaders.forEach(accordianItemHeader => {
                        accordianItemHeader.addEventListener("click", () => {
                            const current = document.querySelector(".accordian-item-header.active");

                            if (current && current !== accordianItemHeader) {
                                current.classList.toggle("active");
                                current.nextElementSibling.style.maxHeight = 0;
                            }

                            accordianItemHeader.classList.toggle("active");
                            const accordianItemBody = accordianItemHeader.nextElementSibling;

                            if (accordianItemHeader.classList.contains("active")) {
                                accordianItemBody.style.maxHeight = accordianItemBody.scrollHeight + "px";
                            } else {
                                accordianItemBody.style.maxHeight = 0;
                            }
                        });
                    });
                });
            } else {
                this.blankMsg = "문의 내역이 <br>존재하지 않습니다.";
            }
        }).catch(err => {
            console.log(err);
        });
    }
};
</script>
